module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1034-2cfde58cb7e994f9864532625f2607c3.png";